import AwaitLock from "await-lock";
import { getLastValuesFromSendedValues } from "./getLastValuesFromSendedValues";
import { getUpdatedCells } from "./getUpdatedCells";
import { handleCellValue } from "./handleCellValue";
import * as Sentry from "@sentry/react";
import { OnDataProducerArgs } from "../types";

const lock = new AwaitLock();

interface CellUpdateHandlerArgs extends Omit<OnDataProducerArgs, "event"> {
  address: string;
}

const TIMEOUT = 10000;

export const cellUpdateHandler = async ({
  address,
  onSaveSecurityInStaging,
  onSetQuoteFeedAsNone,
}: CellUpdateHandlerArgs) => {
  await lock.acquireAsync({ timeout: TIMEOUT });

  try {
    const updatedCells = getUpdatedCells(address);

    await getLastValuesFromSendedValues();
    for (const cell of updatedCells) await handleCellValue({ cell, onSaveSecurityInStaging, onSetQuoteFeedAsNone });
  } catch (error) {
    console.log("Error while handling onDataProducerCalculated event", error);

    Sentry.captureException({
      message: "Error while handling onDataProducerCalculated event",
      level: "error",
      data: error,
    });
  } finally {
    lock.release();
  }
};
